import { IUserLoginInfo } from '@models';

export enum TaskPriority {
    /// <summary>
    ///     Tasks with this priority need user action before tasks with any other priority
    /// </summary>
    Critical = 'Critical',

    /// <summary>
    ///     Tasks with this priority need user action before tasks with Medium and Low priorities
    /// </summary>
    High = 'High',

    /// <summary>
    ///     Tasks with this priority need user action before tasks with Low priority
    /// </summary>
    Medium = 'Medium',

    /// <summary>
    ///     Tasks with this priority need user action after tasks with any other priority
    /// </summary>
    Low = 'Low',
}

export enum TaskStatus {

    /// <summary>
    /// Tasks that are unassigned to any business user for completion
    /// </summary>
    Unassigned = 'Unassigned',

    /// <summary>
    /// Tasks assigned to the user but pending completion
    /// </summary>
    Pending = 'Pending',

    /// <summary>
    /// Tasks on which action was taken
    /// </summary>
    Completed = 'Completed',
}

export enum TaskType {

    /// <summary>
    /// Task whose details can be viewed via a simple form
    /// </summary>
    FormTask = 'FormTask',
}

export interface ITask {
    id: number;
    taskPriority: TaskPriority;
    title: string;
    creationTime: Date;
    status: TaskStatus;
    type: TaskType;
    assignedToUser: IUserLoginInfo;
    taskCatalogName: string;
    organizationUnitId: number;
    isCompleted: boolean;
}

export interface ITaskAssignmentRequest {
    userId?: number;
    taskId: number;
}

export interface ITaskAssignmentErrorResponse {
    userId?: number;
    taskId: number;
    errorCode: number;
    errorMessage: string;
}

export enum TaskModalType {
    Assign,
    Reassign,
    Unassign,
}
